import { render, staticRenderFns } from "./DispatcherTasks.vue?vue&type=template&id=19e79f0a&"
import script from "./DispatcherTasks.vue?vue&type=script&lang=js&"
export * from "./DispatcherTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports